import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Rapidfreeservices() {
  return (
    <section
      className="rapid_free_services p-100 cloud_opt_process"
      style={{ backgroundColor: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={11} lg={10} className="m-auto text-center">
            <h3 className="h3_head">
              Why to Choose TekRevol As Your{" "}
              <span>Custom Blockchain App Development Company?</span>
            </h3>
            <p>
              At TekRevol, we reinvent organizations with blockchain application
              solutions and services while integrating the best practices into
              our services. Our team is skilled in modern technologies such as
              blockchain that provide solutions for secure, accurate, and
              cost-effective solutions according to clients’ requirements.
            </p>
            <p>
              Bearing the rich experience and commitment, we offer reliable and
              exhaustive blockchain solutions that help ensure growth and
              efficiency in your business.
            </p>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="rapid_box">
              <div className="rapid_num">01</div>
              <div className="rapid_content">
                <h5>Expertise in Diverse Solutions</h5>
                <p>
                  We offer a wide range of blockchain services, from dApp
                  development to asset tokenization, ensuring comprehensive
                  solutions for all your business needs.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="rapid_box">
              <div className="rapid_num">02</div>
              <div className="rapid_content">
                <h5>Advanced Technical Proficiency</h5>
                <p>
                  Our team stays at the forefront of blockchain technology,
                  employing the latest techniques and best practices to deliver
                  high-performance applications.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="rapid_box">
              <div className="rapid_num">03</div>
              <div className="rapid_content">
                <h5>Customized Solutions</h5>
                <p>
                  We develop tailored blockchain solutions that align with your
                  unique business requirements, ensuring optimal functionality
                  and efficiency.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="rapid_box">
              <div className="rapid_num">04</div>
              <div className="rapid_content">
                <h5>Secure and Scalable Applications</h5>
                <p>
                  Security and scalability are at the core of our development
                  process, guaranteeing robust applications capable of handling
                  growth and high transaction volumes.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="rapid_box">
              <div className="rapid_num">05</div>
              <div className="rapid_content">
                <h5>Agile Development Methodology</h5>
                <p>
                  Our agile approach allows for iterative development, enabling
                  us to adapt to changes quickly and deliver solutions faster
                  while maintaining high quality.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="rapid_box">
              <div className="rapid_num">06</div>
              <div className="rapid_content">
                <h5>Proven Track Record</h5>
                <p>
                  With numerous successful projects and satisfied clients,
                  TekRevol has a proven history of delivering exceptional
                  blockchain solutions.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Rapidfreeservices;
